<template>
  <div>
    <b-row align-h="between" class="mb-3">
      <b-col cols="4">
        <b-button variant="outline-success" @click="add" v-if="allow('A')">
          <b-icon-plus></b-icon-plus>
          {{$l('btn_create_project') || '创建项目'}}
        </b-button>
      </b-col>
      <b-col cols="6">
        <b-form>
          <b-input-group>
            <b-form-input type="search" v-model="form.prjTitle" placeholder="Search here..." />
            <b-input-group-append>
              <b-button-group>
                <b-dropdown right variant="light" ref="dropdown">
                  <b-dd-form :inline="true" style="width: 400px;">
                    <h6>Filter by</h6>
                    <b-form-row class="mb-2">
                      <b-col cols="12">
                        <b-form-input style="width:100%;" type="search" v-model="form.prjNo" :placeholder="$l('label_search_prjNo') || '项目编号'"></b-form-input>
                      </b-col>
                    </b-form-row>
                    <b-form-row class="mb-2">
                      <b-col cols="12">
                        <b-form-group :label="$l('label_search_customer') || '客户'">
                          <bv-select
                                  v-model="form.custCode"
                                  size="md"
                                  url="/digitalCenter/common/dict/customer"
                          ></bv-select>
                        </b-form-group>
                      </b-col>
                    </b-form-row>
                    <b-form-row class="mb-2">
                      <b-col md="12" lg="12">
                        <b-form-group :label="$l('label_search_category') || '所属分类'">
                          <bv-select
                                  v-model="form.prjCategoryCode"
                                  size="md"
                                  url="/digitalCenter/common/dict/prjCategory">
                          </bv-select>
                        </b-form-group>
                      </b-col>
                    </b-form-row>
                    <b-form-row class="mt-1 mb-2">
                      <b-col md="12" lg="12">
                        <b-form-group  :label="$l('label_search_status') || '状态'">
                          <bv-select
                                  v-model="form.prjStatus"
                                  size="md"
                                  url="/digitalCenter/common/dict/system"
                                  :params="{ dictType: 'prjStatus' }"
                          ></bv-select>
                        </b-form-group>
                      </b-col>
                    </b-form-row>
                    <b-form-row>
                      <b-col style="text-align:center;">
                        <b-button block variant="primary" @click="query">Search</b-button>
                        <b-button block variant="outline-primary" @click="reset">Reset</b-button>
                      </b-col>
                    </b-form-row>
                  </b-dd-form>
                </b-dropdown>
                <b-button variant="primary" class="my-2 my-sm-0" @click="query">
                  <i class="fa fa-search"></i>
                </b-button>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>

    <add-project ref="addProject" />
  </div>
</template>

<script>
import AddProject from '@/views/digital/projectManager/info/components/add'
export default {
  components: {
    AddProject
  },
  data () {
    return {
      form: {
        prjNo: '',
        prjTitle: '',
        prjCategoryCode: '',
        custCode: '',
        prjStatus: '',
        prjStatusList: []
      }
    }
  },
  methods: {
    query () {
      this.form.prjStatusList = []
      if (this.form.prjStatus) {
        this.form.prjStatusList.push(this.form.prjStatus)
      }
      this.$emit('submit', this.form)
    },
    //创建项目
    add() {
      let val = {
        formTitle: this.$l("INDEX.label_title_add_project") || "新增项目",
      };
      this.$refs.addProject.fromLoad("add",val);
      return;
    },
    reset () {
      this.form = {
        prjNo: '',
        prjTitle: '',
        prjCategoryCode: '',
        custCode: '',
        prjStatus:'',
        prjStatusList: []
      }
      this.query()
    }
  },
  created () {
    this.query()
  }
}
</script>
